import {
  Accordion,
  Badge,
  Col,
  FloatingLabel,
  FormGroup,
  FormLabel,
  Row,
  Table,
} from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import moment from "moment/moment";
import Swal from "sweetalert2";
export default function EditFamliyFundForecast() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loanAmountSum, setLoanAmountSum] = useState(0);
  const [resettlementSum, setResettlementSum] = useState(0);
  const [estimatedCostSum, setEstimatedCostSum] = useState(0);
  const [scholarshipSum, setScholarshipSum] = useState(0);
  const [forecast, setForecast] = useState([]);
  const [forecasts, setForecasts] = useState([]);
  const [donors, setDonors] = useState([]);
  const [formState, setFormState] = useState({
    loan_donor_id: null,
    business_donor_id: null,
    resettlement_donor_id: null,
    scholarship_donor_id: null,
    status_id:null
  });
  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
  const [reqs, setReqs] = useState([]);

  useEffect(() => {

    axios.get(process.env.REACT_APP_API_URL + "/edit-forecast/" + id).then((res) => {
      setForecast(res.data.forecast)
      setDonors(res.data.donors)
    });

  }, []);
  useEffect(() => {
    const loanSum = forecast?.families?.reduce((acc, family) => acc + (family.person.loan?.loan_amount || 0), 0);
    const resettlementSum = forecast?.families?.reduce((acc, family) => acc + (family.person.resettlement_amount || 0), 0);
    const estimatedCostSum = forecast?.families?.reduce((acc, family) => acc + (family.person.loan?.estimated_business_cost || 0), 0);
    const scholarshipSum = forecast?.families?.reduce((acc, family) => acc + (family.person.loan?.scholarship_amount || 0), 0);

    setLoanAmountSum(loanSum);
    setResettlementSum(resettlementSum);
    setEstimatedCostSum(estimatedCostSum);
    setScholarshipSum(scholarshipSum);

    setFormState({
      loan_donor_id: forecast?.loan_donor_id || '',
      business_donor_id: forecast?.business_donor_id || '',
      resettlement_donor_id: forecast?.resettlement_donor_id || '',
      scholarship_donor_id: forecast?.scholarship_donor_id || '',
    })
  }, [forecast]);

  const [errors, setErrors] = useState({});

  console.log(formState, 'ok')
  const validateForm = () => {
    const newErrors = {};

    if (loanAmountSum > 0 && !formState.loan_donor_id) {
      newErrors.loan_donor_id = 'Loan Donor must be selected.';
    }
    if (estimatedCostSum > 0 && !formState.business_donor_id) {
      newErrors.business_donor_id = 'Business Donor must be selected.';
    }
    if (resettlementSum > 0 && !formState.resettlement_donor_id) {
      newErrors.resettlement_donor_id = 'Resettlement Donor must be selected.';
    }
    if (scholarshipSum > 0 && !formState.scholarship_donor_id) {
      newErrors.scholarship_donor_id = 'Scholarship Donor must be selected.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (status) => {
  const updatedFormState = {
    ...formState,
    status_id: status,
  };
  
  if (validateForm()) {
    axios.post(process.env.REACT_APP_API_URL + "/update-forecast/" + id, updatedFormState)
      .then((res) => {
        navigate('/family-forecast');
        Swal.fire({
          title: 'Success!',
          text: 'Family Fund Forecast Created Successfully.',
          icon: 'success',
          confirmButtonText: 'Ok'
        });
      });
    
    // Optionally update state after sending if you want:
    setFormState(updatedFormState);
  }
};

  // const mappedData = reqs.map((req) => (
  //   {
  //     req_id: req.,
  //     brick_kiln: Subhan Bricks,
  //     address: Khanewal,
  //     owner_name: Muhammad Nadeem,
  //     owner_cell: N/A,
  //     owner_cnic: 36104-0583943-7,
  //     identifier: Pastor Lazer,
  //     beneficiary_name: Ghulam Guffar,
  //     beneficiary_cnic: 35102-2928748-7,
  //     partner_incentive: 0,
  //     loan_amount: 100,000\n(Conduit Church),
  //     resettlement_amount: 39,500\n(Conduit Church),
  //     buisness_amount: 275,000\n(Conduit Church),
  //     scholarship_amount: 0,
  //     total_amount: 414,500,
  //     family_debt_evidence: N/A,
  //     status: "Approved",
  //     actions: { "edit": "edit" }
  //   }
  // ));
  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                {"Edit Family Fund Forecast"}
              </h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"home"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {"Finances"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  {" Edit Family Fund Forecast"}
                </li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-card-header">
              <h5>Fund Forecast {forecast?.rfq_id}</h5>
            </div>

            {/* Loan Section */}
            <Row>
              <Col className="md-3">
                <FormGroup>
                  <FloatingLabel label="Loan Amount" className="mb-3">
                    <Form.Control type="text" value={loanAmountSum} readOnly />
                  </FloatingLabel>
                </FormGroup>
              </Col>
              <Col className="md-3">
                <FormGroup>
                  <FloatingLabel label="Loan Donor" className="mb-3">
                    <Form.Select name="loan_donor_id" value={formState.loan_donor_id} onChange={handleChange}>
                      <option value="">Select Loan Donor</option>
                      {donors.map((donor) => (
                        <option key={donor.id} value={donor.id}>
                          {donor.name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.loan_donor_id && <span className="text-danger">{errors.loan_donor_id}</span>}
                  </FloatingLabel>
                </FormGroup>
              </Col>
            </Row>

            {/* Business Section */}
            <Row>
              <Col className="md-3">
                <FormGroup>
                  <FloatingLabel label="Business Amount" className="mb-3">
                    <Form.Control type="text" value={estimatedCostSum} readOnly />
                  </FloatingLabel>
                </FormGroup>
              </Col>
              <Col className="md-3">
                <FormGroup>
                  <FloatingLabel label="Business Donor" className="mb-3">
                    <Form.Select name="business_donor_id" value={formState.business_donor_id} onChange={handleChange}>
                      <option value="">Select Business Donor</option>
                      {donors.map((donor) => (
                        <option key={donor.id} value={donor.id}>
                          {donor.name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.business_donor_id && <span className="text-danger">{errors.business_donor_id}</span>}
                  </FloatingLabel>
                </FormGroup>
              </Col>
            </Row>

            {/* Resettlement Section */}
            <Row>
              <Col className="md-3">
                <FormGroup>
                  <FloatingLabel label="Resettlement Amount" className="mb-3">
                    <Form.Control type="text" value={resettlementSum} readOnly />
                  </FloatingLabel>
                </FormGroup>
              </Col>
              <Col className="md-3">
                <FormGroup>
                  <FloatingLabel label="Resettlement Donor" className="mb-3">
                    <Form.Select name="resettlement_donor_id" value={formState.resettlement_donor_id} onChange={handleChange}>
                      <option value="">Select Resettlement Donor</option>
                      {donors.map((donor) => (
                        <option key={donor.id} value={donor.id}>
                          {donor.name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.resettlement_donor_id && <span className="text-danger">{errors.resettlement_donor_id}</span>}
                  </FloatingLabel>
                </FormGroup>
              </Col>
            </Row>

            {/* Scholarship Section */}
            <Row>
              <Col className="md-3">
                <FormGroup>
                  <FloatingLabel label="Scholarship Amount" className="mb-3">
                    <Form.Control type="text" value={scholarshipSum} readOnly />
                  </FloatingLabel>
                </FormGroup>
              </Col>
              <Col className="md-3">
                <FormGroup>
                  <FloatingLabel label="Scholarship Donor" className="mb-3">
                    <Form.Select name="scholarship_donor_id" value={formState.scholarship_donor_id} onChange={handleChange}>
                      <option value="">Select Scholarship Donor</option>
                      {donors.map((donor) => (
                        <option key={donor.id} value={donor.id}>
                          {donor.name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.scholarship_donor_id && <span className="text-danger">{errors.scholarship_donor_id}</span>}
                  </FloatingLabel>
                </FormGroup>
              </Col>
            </Row>

            {/* Total Amount and Submit */}
            <Row>
              <Col>
                <FormGroup>
                  <FloatingLabel label="Total Amount" className="mb-3">
                    <Form.Control
                      type="text"
                      value={loanAmountSum + estimatedCostSum + resettlementSum + scholarshipSum}
                      readOnly
                    />
                  </FloatingLabel>
                </FormGroup>
              </Col>
              <Col className="text-center">
                {
                  forecast?.status_id === 1 ?
                    <Button variant="primary" className="mt-2 w-100" onClick={() => handleSubmit(2)}>
                      Forward To Account
                    </Button> :
                    forecast?.status_id === 2 ?
                     
                      <><Button variant="success" className="mt-3 w-50" onClick={() => handleSubmit(4)}>Approve</Button>
                        <Button variant="danger" className="ml-5 mt-3 " onClick={() => handleSubmit(5)}>Reject</Button>
                      </>
                      : ''
                }

              </Col>
            </Row>
          </div>
        </Col>



        <Col xl={12}>
          <div className="mc-card">

            <Row>
              {forecast?.families?.map((forecast, index) => (
                <div key={forecast.id} style={{ marginBottom: "20px" }}>
                  <h4>{"Family Fund Forecast " + (index + 1)}</h4>
                  <Row>
                    <Form.Group as={Col} md="4">
                      <FloatingLabel label="Draft Family FSF-ID" className="mb-3">
                        <Form.Control
                          required
                          type="text"
                          name="fsf_id"
                          placeholder=""
                          value={forecast.person.f_number ?? ""}
                          readOnly
                        />
                      </FloatingLabel>
                    </Form.Group>

                    {/* Other fields (not editable) */}
                    <Form.Group as={Col} md="4">
                      <FloatingLabel label="Family Identifier" className="mb-3">
                        <Form.Control
                          required
                          type="text"
                          name="familyIdentifier"
                          placeholder=""
                          value={forecast.person.identifier.name ?? ""}
                          readOnly
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <FloatingLabel label="Brick Kiln" className="mb-3">
                        <Form.Control
                          required
                          type="text"
                          name="brickKiln"
                          placeholder=""
                          value={forecast.person.brick_kiln.brickkiln_name ?? ""}
                          readOnly
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <FloatingLabel label="Brick Kiln Owner Name..." className="mb-3">
                        <Form.Control
                          required
                          type="text"
                          name="brickKilnOwnerName"
                          placeholder=""
                          value={forecast.person.brick_kiln.brickkiln_owner ?? ""}
                          readonly
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <FloatingLabel label="Brick Kiln Owner Cell..." className="mb-3">
                        <Form.Control
                          required
                          type="text"
                          name="brickKilnOwnerCell"
                          placeholder=""
                          value={forecast.person.brick_kiln.brickkiln_owner_cell ?? ""}
                          readonly
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <FloatingLabel label="Brick Kiln Owner Cnic..." className="mb-3">
                        <Form.Control
                          required
                          type="text"
                          name="brickKilnOwnerCnic"
                          placeholder=""
                          value={forecast.person.brick_kiln.owner_cnic ?? ""}
                          readonly
                        />
                      </FloatingLabel>
                    </Form.Group>


                    <Form.Group as={Col} md="4">
                      <FloatingLabel label="Beneficiary Name..." className="mb-3">
                        <Form.Control
                          required
                          type="text"
                          name="name"
                          placeholder=""
                          value={forecast.person.beneficiary_name ?? ""}
                          readonly
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <FloatingLabel label="Beneficiary CNIC" className="mb-3">
                        <Form.Control
                          required
                          type="text"
                          name="cnic"
                          placeholder=""
                          value={forecast.person.cnic ?? ""}
                          readonly
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <FloatingLabel label="Loan Amount..." className="mb-3">
                        <Form.Control
                          required
                          type="text"
                          name="loanAmount"
                          placeholder=""
                          value={forecast.person.loan.loan_amount ?? ""}
                          readonly
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <FloatingLabel label="Resettlement Amount..." className="mb-3">
                        <Form.Control
                          required
                          type="text"
                          name="resettlementAmount"
                          placeholder=""
                          value={forecast.person.resettlement_amount ?? ""}
                          readonly
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <FloatingLabel label="Business Amount..." className="mb-3">
                        <Form.Control
                          required
                          type="text"
                          name="buisnessAmount"
                          placeholder=""
                          value={forecast.person.loan?.estimated_business_cost ?? ""}
                          readonly
                        />
                      </FloatingLabel>
                    </Form.Group>
                    {/* Editable fields */}
                    <Form.Group as={Col} md="4">
                      <FloatingLabel label="Scholarship Amount..." className="mb-3">
                        <Form.Control
                          required
                          type="text"
                          name="scholarshipAmount"
                          placeholder=""
                          value={forecast.person.loan.scholarship_amount ?? ""}
                          readOnly
                        />
                      </FloatingLabel>
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <FloatingLabel label="Partner Incentive..." className="mb-3">
                        <Form.Control
                          required
                          type="text"
                          name="partnerIncentive"
                          placeholder=""
                          value={forecast.person.loan.incentive ?? ""}
                          readOnly
                        />
                      </FloatingLabel>
                    </Form.Group>

                    {/* Delete button */}

                  </Row>
                </div>
              ))}
            </Row>
          </div>
        </Col>
      </Row>

      <Row>

      </Row>
    </PageLayout>
  );
}
